import { indexBy, mapObjIndexed, pipe, prop } from 'ramda';
import { Category } from 'api/timesheets/categories';
import { Loaded, Loading } from 'core/state';
import { CategoriesStore, from, to } from './core';

export const loading = pipe(
  from,
  (x: CategoriesStore) => ({ ...x, ids: Loading() } as CategoriesStore),
  to,
);
export const loaded = (data: Category[]) =>
  pipe(
    from,
    (categories) => ({
      ...categories,
      byId: mapObjIndexed<Category, Loaded<Category>>(
        Loaded,
        indexBy(prop('id'), data),
      ),
      ids: Loaded(data.map((x) => x.id)),
    }),
    to,
  );
